import axios from "axios"

axios.defaults.baseURL = '/v1';

export default class CallAPI {
  static async get(url, params) {
    return await axios.get(url, { params });
  }

  static async post(url, data) {
    return await axios.post(url, data);
  }

  static async put(url, data) {
    return await axios.put(url, data);
  }

  static async delete(url) {
    return await axios.delete(url);
  }
}
